import { ConfigPedidoCondicoesPagamentoForm } from 'pages/compra/configuracao-pedido/components/form/condicoes-pagamento/ConfigPedidoCondicoesPagamentoForm';
import { ConfigPedidoCondicoesVisualizacaoForm } from 'pages/compra/configuracao-pedido/components/form/condicoes-visualizacao/ConfigPedidoCondicoesVisualizacaoForm';
import { ConfigPedidoDadosBasicosForm } from 'pages/compra/configuracao-pedido/components/form/dados-basicos/ConfigPedidoDadosBasicosForm';
import { ConfigPedidoImportarEstoqueForm } from 'pages/compra/configuracao-pedido/components/form/importar-estoque/ConfigPedidoImportarEstoqueForm';
import { ConfigPedidoPedidosSazonaisForm } from 'pages/compra/configuracao-pedido/components/form/pedidos-sazonais/ConfigPedidoPedidosSazonaisForm';
import { ConfigPedidoProdutosForm } from 'pages/compra/configuracao-pedido/components/form/produtos/ConfigPedidoProdutosForm';
import { ConfigPedidoQuebrasDinamicasForm } from 'pages/compra/configuracao-pedido/components/form/quebras-dinamicas/ConfigPedidoQuebrasDinamicasForm';
import { ConfigPedidoRegrasValidacaoForm } from 'pages/compra/configuracao-pedido/components/form/regras-validacao/ConfigPedidoRegrasValidacaoForm';
import { ConfigPedidoStep } from 'pages/compra/configuracao-pedido/contexts/ConfigPedidoStepContext';

export const ENABLED_STEPS_EDIT = ['condicoesPagamento', 'quebrasDinamicas', 'produto', 'regrasValidacao', 'condicoesVisualizacao', 'dadosBasicos'];

export const INITIAL_STEP = 'dadosBasicos';

export const STEP_LIST: ConfigPedidoStep[] = [
    {
        dsConfigPedidoStep: 'Dados básicos',
        dsChaveConfigPedidoStep: 'dadosBasicos',
        fgSaved: false,
        fgDirty: false,
        fgDisabled: false,
        component: <ConfigPedidoDadosBasicosForm />,
    },
    {
        dsConfigPedidoStep: 'Condições de visualização',
        dsChaveConfigPedidoStep: 'condicoesVisualizacao',
        fgSaved: false,
        fgDirty: false,
        fgDisabled: true,
        component: <ConfigPedidoCondicoesVisualizacaoForm />,
    },
    {
        dsConfigPedidoStep: 'Condições de pagamento',
        dsChaveConfigPedidoStep: 'condicoesPagamento',
        fgSaved: false,
        fgDirty: false,
        fgDisabled: true,
        component: <ConfigPedidoCondicoesPagamentoForm />,
    },
    {
        dsConfigPedidoStep: 'Regras de validação',
        dsChaveConfigPedidoStep: 'regrasValidacao',
        fgSaved: false,
        fgDirty: false,
        fgDisabled: true,
        component: <ConfigPedidoRegrasValidacaoForm />,
    },
    {
        dsConfigPedidoStep: 'Produtos',
        dsChaveConfigPedidoStep: 'produto',
        fgSaved: false,
        fgDirty: false,
        fgDisabled: true,
        component: <ConfigPedidoProdutosForm />,
    },
    {
        dsConfigPedidoStep: 'Importar estoque',
        dsChaveConfigPedidoStep: 'importarEstoque',
        fgSaved: false,
        fgDirty: false,
        fgDisabled: true,
        component: <ConfigPedidoImportarEstoqueForm />,
    },
    {
        dsConfigPedidoStep: 'Quebras dinâmicas',
        dsChaveConfigPedidoStep: 'quebrasDinamicas',
        fgSaved: false,
        fgDirty: false,
        fgDisabled: true,
        component: <ConfigPedidoQuebrasDinamicasForm />,
    },
    {
        dsConfigPedidoStep: 'Pedidos sazonais',
        dsChaveConfigPedidoStep: 'sazonal',
        fgSaved: false,
        fgDirty: false,
        fgDisabled: true,
        component: <ConfigPedidoPedidosSazonaisForm />,
    },
];
